/**
 * Copyright IBM Corp. 2022, 2026
 */

import { vercelSplit } from '@web/cms'
import HDSTable from 'components/hds-table'
import type { StructuredTextFieldsFragment } from 'types/dato'
import s from './style.module.css'

type BlocksType = StructuredTextFieldsFragment['body']['blocks'][number]
type TableType = Extract<BlocksType, { __typename: 'StTableRecord' }>

export default function Table({ table }: TableType) {
	return (
		<div className={s.tableBlock}>
			<div className={s.tableContainer}>
				<HDSTable table={vercelSplit(table)} />
			</div>
		</div>
	)
}
